import React from 'react';
import { Helmet } from 'react-helmet';
/**
 * component
 */
import Layout from '../../components/layout';
import Header from '../../components/header';
import { Container, makeStyles, Grid } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  wrapper: {
    paddingTop: '90px',
  },
  logo: {
    borderColor: '#e1e1e1',
    borderStyle: 'solid',
    borderWidth: '1px',
    padding: '7px',
    borderRadius: '0',
  },
  bottom: {
    height: '500px',
    [theme.breakpoints.up('md')]: {
      height: '700px',
    },
  },
  font: {
    fontSize: '20px',
    lineHeight: '1.1em',
    marginBottom: '8px',
    textAlign: 'center',
  },
  hr: {
    marginTop: '20px',
    marginBottom: '20px',
    textAlign: 'center',
    borderColor: '#e1e1e1',
    clear: 'both',
    display: 'block',
    width: '100%',
    height: '25px',
    lineHeight: '25px',
    position: 'relative',
    margin: '30px 0',
    float: 'left',
    borderTopWidth: '1px',
    borderTopStyle: 'solid',
  },
  innerImg: {
    width: '100%',
    textAlign: 'center',
    float: 'left',
  },
}));

export default function Partners() {
  const classes = useStyles();
  return (
    <Layout>
      <Helmet>
        <title>MALGN | 협력사/고객사</title>
      </Helmet>
      <Container maxWidth="md">
        <div className={classes.wrapper}>
          <Grid container spacing={7}>
            <Grid item xs={12} sm={6}>
              <div className={classes.wrapper}>
                <p className={classes.font}>협력사</p>
              </div>
              <div className={classes.hr} />
              <Grid container>
                <Grid item xs={3} className={classes.logo}>
                  <img
                    src="/img/partners/Apple_Authorized_2-removebg.png"
                    alt
                  />
                </Grid>
                <Grid item xs={3} className={classes.logo}>
                  <img src="/img/partners/spectra.png" alt />
                </Grid>
                <Grid item xs={3} className={classes.logo}>
                  <img src="/img/partners/fujitsu.png" alt />
                </Grid>
                <Grid item xs={3} className={classes.logo}>
                  <img src="/img/partners/quantum1.png" alt />
                </Grid>
                <Grid item xs={3} className={classes.logo}>
                  <img src="/img/partners/promise_logo.png" alt />
                </Grid>
                <Grid item xs={3} className={classes.logo}>
                  <img src="/img/partners/loxoll1.png" alt />
                </Grid>
                <Grid item xs={3} className={classes.logo}>
                  <img src="/img/partners/paox1.png" alt />
                </Grid>
                <Grid item xs={3} className={classes.logo}>
                  <img src="/img/partners/harmonic.png" alt />
                </Grid>
                <Grid item xs={3} className={classes.logo}>
                  <img src="/img/partners/archiware_logo.png" alt />
                </Grid>
                <Grid item xs={3} className={classes.logo}>
                  <img src="/img/partners/hpe_logo.png" alt />
                </Grid>
                <Grid item xs={3} className={classes.logo}>
                  <img src="/img/partners/softron_logo.png" alt />
                </Grid>
                <Grid item xs={3} className={classes.logo}>
                  <img src="/img/partners/dell.png" alt />
                </Grid>
                <Grid item xs={3} className={classes.logo}>
                  <img src="/img/partners/areca.png" alt />
                </Grid>
                <Grid item xs={3} className={classes.logo}>
                  <img src="/img/partners/qualstar.png" alt />
                </Grid>
                <Grid item xs={3} className={classes.logo}>
                  <img src="/img/partners/qnap.png" alt />
                </Grid>
                <Grid item xs={3} className={classes.logo}>
                  <img src="/img/partners/overland.png" alt />
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12} sm={6}>
              <div className={classes.wrapper}>
                <p className={classes.font}>고객사</p>
              </div>
              <div className={classes.hr} />
              <Grid container>
                <Grid item xs={3} className={classes.logo}>
                  <img src="/img/partners/kbs_n.png" alt />
                </Grid>
                <Grid item xs={3} className={classes.logo}>
                  <img src="/img/partners/ebs1.png" alt />
                </Grid>
                <Grid item xs={3} className={classes.logo}>
                  <img src="/img/partners/ktv1.png" alt />
                </Grid>
                <Grid item xs={3} className={classes.logo}>
                  <img src="/img/partners/vtc1.png" alt />
                </Grid>
                <Grid item xs={3} className={classes.logo}>
                  <img src="/img/partners/kdn.png" alt />
                </Grid>
                <Grid item xs={3} className={classes.logo}>
                  <img src="/img/partners/nstp.png" alt />
                </Grid>
                <Grid item xs={3} className={classes.logo}>
                  <img src="/img/partners/cmb.png" alt />
                </Grid>
                <Grid item xs={3} className={classes.logo}>
                  <img src="/img/partners/nis_logo.png" alt />
                </Grid>
                <Grid item xs={3} className={classes.logo}>
                  <img src="/img/partners/mbc_logo.png" alt />
                </Grid>
                <Grid item xs={3} className={classes.logo}>
                  <img src="/img/partners/goodtv.png" alt />
                </Grid>
                <Grid item xs={3} className={classes.logo}>
                  <img src="/img/partners/cjenm.png" alt />
                </Grid>
                <Grid item xs={3} className={classes.logo}>
                  <img src="/img/partners/cbs.png" alt />
                </Grid>
                <Grid item xs={3} className={classes.logo}>
                  <img src="/img/partners/fire.png" alt />
                </Grid>
                <Grid item xs={3} className={classes.logo}>
                  <img src="/img/partners/ysg.png" alt />
                </Grid>
                <Grid item xs={3} className={classes.logo}>
                  <img src="/img/partners/eco.png" alt />
                </Grid>
                <Grid item xs={3} className={classes.logo}>
                  <img src="/img/partners/sbs.png" alt />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </div>
      </Container>
      <Container className={classes.bottom} />
    </Layout>
  );
}
